import React, { lazy, Suspense, useEffect } from "react";
const VerifyEmail = lazy(
   () => import("../pages/utility/VerifyEmail/VerifyEmail"),
);
const LogIn = lazy(() => import("../pages/utility/LogIn/LogIn"));
const Register = lazy(() => import("../pages/utility/Register/Register"));
const PasswordReset = lazy(
   () => import("../pages/utility/PasswordReset/PasswordReset"),
);
const ErrorPage = lazy(() => import("../pages/utility/ErrorPage/ErrorPage"));
const SSOLandingPage = lazy(
   () => import("../pages/utility/SSO/SSOLandingPage"),
);
import { ECLLoader } from "../eclComponents";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import ECLUtility from "../pages/utility/ECLUtility/ECLUtility";

const UtilityRouter = () => {
   const navigate = useNavigate();

   useEffect(() => {
      //Check for a url parameter, which will hold a redirect we want to use after getting into app/logging in
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const redirect = urlParams.get("url");
      if (redirect && redirect.includes("/sourceone/utility/")) {
         urlParams.delete("url"); //Remove redirection url
         navigate({
            pathname: redirect,
            search: urlParams.toString(),
         });
      } else {
         if (urlParams?.get("url")?.includes("login")) {
            urlParams.delete("url");
         }
         navigate({
            pathname: "/sourceone/login",
            search: "?" + urlParams.toString(),
         });
      }
   }, []);

   return (
      <ECLUtility>
         <Routes>
            <Route
               path="/sourceone/"
               element={
                  <Suspense fallback={<ECLLoader />}>
                     <LogIn />
                  </Suspense>
               }
            />
            <Route
               path="/sourceone/login"
               element={
                  <Suspense fallback={<ECLLoader />}>
                     <LogIn />
                  </Suspense>
               }
            />
            <Route
               path="/sourceone/utility/verify-email"
               element={
                  <Suspense fallback={<ECLLoader />}>
                     <VerifyEmail />
                  </Suspense>
               }
            />
            <Route
               path="/sourceone/utility/error"
               element={
                  <Suspense fallback={<ECLLoader />}>
                     <ErrorPage />
                  </Suspense>
               }
            />
            <Route
               path="/sourceone/utility/register"
               element={
                  <Suspense fallback={<ECLLoader />}>
                     <Register />
                  </Suspense>
               }
            />
            <Route
               path="/sourceone/utility/password-reset"
               element={
                  <Suspense fallback={<ECLLoader />}>
                     <PasswordReset />
                  </Suspense>
               }
            />
            <Route
               path="/sourceone/utility/sso-landing-page"
               element={
                  <Suspense fallback={<ECLLoader />}>
                     <SSOLandingPage />
                  </Suspense>
               }
            />
            <Route
               path="/sourceone/*"
               element={<Navigate to="/sourceone/" />}
            />
         </Routes>
         <div id="ECLModal" role="alertdialog"></div>
      </ECLUtility>
   );
};

export default UtilityRouter;
